import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { CKEditorModule } from '@ckeditor/ckeditor5-angular';
import { DateInputsModule } from '@progress/kendo-angular-dateinputs';
import { EditorModule } from '@progress/kendo-angular-editor';
import { InputsModule } from '@progress/kendo-angular-inputs';
import { ImageCropperModule } from 'ngx-image-cropper';
import { ExhibitDesignerComponent } from './exhibits/exhibit-designer/exhibit-designer.component';
import { MyLiveEventsComponent } from './my-account/my-live-events/my-live-events.component';
import { ScheduleEventComponent } from './my-account/my-live-events/schedule-event/schedule-event.component';
import { MyPostersComponent } from './my-account/posters/my-posters.component';
import { CallForPostersComponent } from './posters/call-for-posters/call-for-posters.component';
import { ApplicationPipesModule } from './_shared/modules/application-pipes.module';

@NgModule({
  declarations:[
    ExhibitDesignerComponent,
    MyPostersComponent,
    CallForPostersComponent,
    MyLiveEventsComponent,
    ScheduleEventComponent
  ],
  entryComponents:[],
  imports:[
    ApplicationPipesModule,
    ImageCropperModule,
    EditorModule,
    DateInputsModule,
    CKEditorModule,
    RouterModule,
    InputsModule,
  ],
  exports:[
    ExhibitDesignerComponent,
    MyPostersComponent,
    CallForPostersComponent,
    MyLiveEventsComponent,
    ScheduleEventComponent

  ]
})
export class SharedAccountConferenceModule{}
